import { ConsumerTagNames } from '@afterpaytouch/portal-api/consumer/tags'

export type TagsResponse = string[]
export interface TagsRequest {
  name: string
  data?: string
}

export interface ConsumerTag {
  [key: string]: string | null
}

export const NEW_USER_PENDING_HARD_CREDIT_CHECK = ConsumerTagNames.NewUserPendingHardCreditCheck
export const BIOMETRIC_DENIED_COUNT_KEY = ConsumerTagNames.BiometricDeniedCount
export const BIOMETRIC_LAST_DENIED_DATE_KEY = ConsumerTagNames.BiometricLastDeniedDate
